import {createSvgIcon} from '../create-svg-icon';

export const TurnRightIcon = createSvgIcon(
  <path d="m17.17 11-1.59 1.59L17 14l4-4-4-4-1.41 1.41L17.17 9H9c-1.1 0-2 .9-2 2v9h2v-9h8.17z" />
, 'TurnRightOutlined');
